module.exports = __webpack_public_path__ + "img/kassa24.f4c2d189.svg";